import { Tabs } from 'components/core-v2'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'

import { PATH } from '@/const'

import { TradeFeesBreakdownTab } from '../../components/trade-fees-breakdown-tab'
import { TradeFeesRatesTab } from '../../components/trade-fees-rates-tab'
import { TradeTemplate } from '../../templates/trade-template'

export const ReportingTradeFeesPage = () => {
  const { '*': splat, source, tradeId } = useParams()
  const [tab] = splat.split('/')

  return (
    <TradeTemplate tabValue="fees">
      <Tabs.List aria-label="Fees tabs" ruleClassName="mb-8" spacing="md">
        <Tabs.Tab
          isSelected={tab === 'rates'}
          to={PATH.reportsSingleTradeFeesRates(source, tradeId)}
          value="rates"
        >
          Current fee rates
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={tab === 'breakdown'}
          to={PATH.reportsSingleTradeFeesBreakdownTotal(source, tradeId)}
          value="breakdown"
        >
          Breakdown
        </Tabs.Tab>
        {/* <Tabs.Tab
          isSelected={page === 'history'}
          to={PATH.reportsSingleTradeFeesHistory(source, tradeId)}
          value="history"
        >
          History
        </Tabs.Tab> */}
      </Tabs.List>
      <Routes>
        <Route
          element={<Navigate to={PATH.reportsSingleTradeFeesBreakdownTotal(source, tradeId)} />}
          path=""
        />
        <Route element={<TradeFeesRatesTab />} path="rates" />
        <Route element={<TradeFeesBreakdownTab />} path="breakdown/*" />
        {/* <Route element={<p>history</p>} path="history" /> */}
      </Routes>
    </TradeTemplate>
  )
}
